import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { usePermission } from '../../hooks/usePermission';
import { Feature } from '../../hooks/usePermission';
import './Layout.css';

interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
}

interface MenuItem {
  path: string;
  label: string;
  icon?: string;
  feature?: Feature;
}

const STAFF_MENU: MenuItem[] = [
  { path: '/', label: '대시보드', feature: 'dashboard_view' },
  { path: '/apartments', label: '장소 관리', feature: 'apartments_view' },
  { path: '/events', label: '과속 이력', feature: 'events_view' },
  { path: '/members', label: '회원 관리', feature: 'members_view' },
  { path: '/companies', label: '회사 관리', feature: 'companies_manage' },
  { path: '/stats', label: '통계', feature: 'stats_view' },
  { path: '/announcements', label: '공지 관리', feature: 'announcements_manage' },
  { path: '/audit-log', label: '감사 로그', feature: 'audit_log_view' },
];

const USER_MENU: MenuItem[] = [
  { path: '/my-events', label: '나의 과속 이력' },
];

const Sidebar: React.FC<SidebarProps> = ({ isOpen, onClose }) => {
  const { canAccess, isUser } = usePermission();
  // ENH-001 — 로고 클릭 시 역할별 홈으로 이동.
  const navigate = useNavigate();
  const goHome = () => {
    navigate(isUser ? '/my-events' : '/');
    onClose();
  };

  const items = isUser
    ? USER_MENU
    : STAFF_MENU.filter((m) => !m.feature || canAccess(m.feature));

  return (
    <>
      {isOpen && <div className="sidebar-overlay" onClick={onClose} />}
      <aside className={`sidebar ${isOpen ? 'sidebar--open' : ''}`}>
        <div
          className="sidebar__logo sidebar__logo--clickable"
          onClick={goHome}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') goHome(); }}
        >
          <span className="sidebar__logo-text">NUCODE</span>
        </div>
        <nav className="sidebar__nav">
          {items.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `sidebar__link ${isActive ? 'sidebar__link--active' : ''}`
              }
              onClick={onClose}
              end={item.path === '/'}
            >
              {item.icon && <span className="sidebar__icon">{item.icon}</span>}
              <span className="sidebar__label">{item.label}</span>
            </NavLink>
          ))}
        </nav>
      </aside>
    </>
  );
};

export default Sidebar;
